declare global {
    interface Window {
        GATEWAY_URL: string;
        REDIRECT_URI: string;
        AD_APP_APP_URI: string;
        AD_APP_TENANT_ID: string;
        AD_APP_CLIENT_ID: string;
        APP_ENVIRONMENT: string;
    }
}

function getEnvValue(key: string, windowKey: string): string {
    // First try window object (production)
    if (window[windowKey as keyof Window]) {
        return window[windowKey as keyof Window] as string;
    }
    // Then try Vite env (development)
    const viteKey = `VITE_${key}`;
    const envValue = import.meta.env[viteKey as keyof ImportMetaEnv];
    if (envValue) {
        return envValue;
    }
    // Fallback to empty string
    return '';
}

export function getGatewayUrl(): string {
    return getEnvValue('GATEWAY_URL', 'GATEWAY_URL');
}

export function getRedirectUri(): string {
    return getEnvValue('REDIRECT_URI', 'REDIRECT_URI');
}

export function getAppUri(): string {
    return getEnvValue('AD_APP_APP_URI', 'AD_APP_APP_URI');
}

export function getAppTenantId(): string {
    return getEnvValue('AD_APP_TENANTID', 'AD_APP_TENANT_ID');
}

export function getAppClientId(): string {
    return getEnvValue('AD_APP_CLIENTID', 'AD_APP_CLIENT_ID');
}

export function getAppEnvironment(): string {
    return getEnvValue('ENVIRONMENT', 'APP_ENVIRONMENT');
}